import state from "./moduleMPMValidateState.js";
import mutations from "./moduleMPMValidateMutations.js";
import actions from "./moduleMPMValidateActions.js";
import getters from "./moduleMPMValidateGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
